// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `input,
div:focus-visible {
    outline: none;
}

#vid-sdk {
    display: flex !important;
    justify-content: center;
}

.video-js {
    position: absolute;
}

input {
    caret-color: #fff;
}
input:autofill::selection {
    background-color: transparent;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    -webkit-text-fill-color: white;
    transition: background-color 5000s ease-in-out 0s;
}

.shaka-text-wrapper span span:nth-last-child(n) {
    background-color: rgba(51, 51, 51, 0.5) !important;
}

.shaka-text-wrapper span span:nth-last-child(n):empty {
    background-color: transparent !important;
}

button[data-class='ribbonItemContent'] div[data-has-border='true'] {
    transition: all 250ms ease-in;
}

button[data-class='ribbonItemContent']:hover div[data-has-border='true'] {
    transform: scale(1.1) translate3D(0px, -5px, 0px);
    border: 2px white solid;
}

div[data-class='epgTimeBar'],
div[data-class='epgChannelList'],
div[data-class='epgDatePicker'],
div[data-class='epgGrid'] {
    -webkit-user-select: none;
    user-select: none;
    outline: 0;
    cursor: pointer;
}

.epgContainerDisabled div div {
    pointer-events: none;
}

.arrowHidden {
    display: none;
}

div[data-class='myListContainer']::-webkit-scrollbar {
    display: none; /* for Chrome, Safari and Opera */
}

div[data-class='myListContainer'] {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    overflow: auto;
}

.channelItem {
    margin-bottom: 8px;
}

.bmpui-ui-subtitle-label > img {
    width: auto !important;
    height: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./index.web.css"],"names":[],"mappings":"AAAA;;IAEI,aAAa;AACjB;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;AACA;IACI,6BAA6B;AACjC;;AAEA;;;;IAII,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iDAAiD;IACjD,uBAAuB;AAC3B;;AAEA;;;;IAII,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa,EAAE,iCAAiC;AACpD;;AAEA;IACI,wBAAwB,EAAE,gBAAgB;IAC1C,qBAAqB,EAAE,YAAY;IACnC,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B","sourcesContent":["input,\ndiv:focus-visible {\n    outline: none;\n}\n\n#vid-sdk {\n    display: flex !important;\n    justify-content: center;\n}\n\n.video-js {\n    position: absolute;\n}\n\ninput {\n    caret-color: #fff;\n}\ninput:autofill::selection {\n    background-color: transparent;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-text-fill-color: white;\n    transition: background-color 5000s ease-in-out 0s;\n}\n\n.shaka-text-wrapper span span:nth-last-child(n) {\n    background-color: rgba(51, 51, 51, 0.5) !important;\n}\n\n.shaka-text-wrapper span span:nth-last-child(n):empty {\n    background-color: transparent !important;\n}\n\nbutton[data-class='ribbonItemContent'] div[data-has-border='true'] {\n    transition: all 250ms ease-in;\n}\n\nbutton[data-class='ribbonItemContent']:hover div[data-has-border='true'] {\n    transform: scale(1.1) translate3D(0px, -5px, 0px);\n    border: 2px white solid;\n}\n\ndiv[data-class='epgTimeBar'],\ndiv[data-class='epgChannelList'],\ndiv[data-class='epgDatePicker'],\ndiv[data-class='epgGrid'] {\n    -webkit-user-select: none;\n    user-select: none;\n    outline: 0;\n    cursor: pointer;\n}\n\n.epgContainerDisabled div div {\n    pointer-events: none;\n}\n\n.arrowHidden {\n    display: none;\n}\n\ndiv[data-class='myListContainer']::-webkit-scrollbar {\n    display: none; /* for Chrome, Safari and Opera */\n}\n\ndiv[data-class='myListContainer'] {\n    -ms-overflow-style: none; /* IE and Edge */\n    scrollbar-width: none; /* Firefox */\n    overflow: auto;\n}\n\n.channelItem {\n    margin-bottom: 8px;\n}\n\n.bmpui-ui-subtitle-label > img {\n    width: auto !important;\n    height: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
